import { render, staticRenderFns } from "./setting-JD-KRA.vue?vue&type=template&id=b72f7c8c&"
import script from "./setting-JD-KRA.vue?vue&type=script&lang=js&"
export * from "./setting-JD-KRA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports